module.exports = __webpack_public_path__ + "3e84daf6f3dd3c98cb94f3ee5ad0495b.jpg";